var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              staticClass: "modal_medium",
              attrs: { persistent: "" },
              model: {
                value: _vm.visible,
                callback: function ($$v) {
                  _vm.visible = $$v
                },
                expression: "visible",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: {
                        method: "post",
                        enctype: "multipart/form-data",
                        "lazy-validation": "",
                      },
                      model: {
                        value: _vm.valid,
                        callback: function ($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid",
                      },
                    },
                    [
                      _c("v-card-title", [
                        _c("span", { staticClass: "headl" }, [
                          _vm._v("NUEVO ESTRATO"),
                        ]),
                      ]),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-container",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: { cols: "12", sm: "12", md: "12" },
                                    },
                                    [
                                      _c("v-text-field", {
                                        ref: "name",
                                        attrs: {
                                          rules: _vm.nameRules,
                                          label: "Nombre",
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.form.name,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "name", $$v)
                                          },
                                          expression: "form.name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6", md: "6" } },
                                    [
                                      _c("v-combobox", {
                                        ref: "activate",
                                        attrs: {
                                          items: _vm.itemsCompany,
                                          "search-input": _vm.search,
                                          "item-value": "_id",
                                          "item-text": "name",
                                          label: "Empresas",
                                          placeholder:
                                            "Digite el nombre de la empresa",
                                          disabled: _vm.isMaster == 0,
                                          clearable: "",
                                          rules: _vm.fieldRules,
                                        },
                                        on: {
                                          "update:searchInput": function (
                                            $event
                                          ) {
                                            _vm.search = $event
                                          },
                                          "update:search-input": function (
                                            $event
                                          ) {
                                            _vm.search = $event
                                          },
                                        },
                                        model: {
                                          value: _vm.form.company,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "company", $$v)
                                          },
                                          expression: "form.company",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6", md: "6" } },
                                    [
                                      _c("v-select", {
                                        ref: "activate",
                                        attrs: {
                                          items: [
                                            { id: "1", name: "Activo" },
                                            { id: "0", name: "Inactivo" },
                                          ],
                                          "item-value": "id",
                                          "item-text": "name",
                                          label: "Estado",
                                          rules: _vm.fieldRules,
                                        },
                                        model: {
                                          value: _vm.form.activate,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "activate", $$v)
                                          },
                                          expression: "form.activate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: { cols: "12", sm: "12", md: "12" },
                                    },
                                    [
                                      _c("v-textarea", {
                                        ref: "description",
                                        attrs: {
                                          outlined: "",
                                          name: "description",
                                          label: "Descripción",
                                        },
                                        model: {
                                          value: _vm.form.description,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "description",
                                              $$v
                                            )
                                          },
                                          expression: "form.description",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _c(
                            "div",
                            { staticClass: "ctn_btn_shop" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { large: "", text: "" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      _vm.show = false
                                    },
                                  },
                                },
                                [_vm._v("Cerrar")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    disabled: !_vm.valid,
                                    depressed: "",
                                    large: "",
                                    color: "primary",
                                  },
                                  on: { click: _vm.validate },
                                },
                                [_vm._v("GUARDAR")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }